import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LaftStatus } from 'src/app/shared/enums/LaftStatus.enum';

export type SignDocumentType = 'declaracion' | 'contrato';

@Component({
  selector: 'app-sign-documents-milestone',
  templateUrl: './sign-documents-milestone.component.html',
  styleUrls: ['./sign-documents-milestone.component.scss'],
})
export class SignDocumentsMilestoneComponent {

  @Input() signed = false;
  @Input() latfStatus: LaftStatus = LaftStatus.Pending;
  @Input() hasContractReadyToSign = false;

  @Output() clickEvent = new EventEmitter<any>();

  readonly LaftStatus = LaftStatus;

  constructor() {}

  isCompleted(): boolean {
    if (this.hasContractReadyToSign) {
      return false;
    }
    return this.latfStatus === LaftStatus.Completed && this.signed;
  }

  get state(): 'completed' | 'incompleted' | 'error' {
    if (this.latfStatus === LaftStatus.Error) return 'error';
    return this.isCompleted() ? 'completed' : 'incompleted';
  }

  get buttonLabel(): string {
    if (this.hasContractReadyToSign) return 'Ir a firmar';
    if (this.latfStatus === LaftStatus.SignatureRequested) return 'Ir a firmar';
    if (
      this.latfStatus === LaftStatus.InProgress ||
      this.latfStatus === LaftStatus.InReview ||
      this.latfStatus === LaftStatus.PepRequested ||
      this.latfStatus === LaftStatus.Completed ||
      this.signed
    )
      return 'Continuar';
    if (this.latfStatus === LaftStatus.Error) return 'Subsanar error';
    return 'Iniciar';
  }

  onSignDocumentsBannerClick(): void {
    this.clickEvent.emit({ laftStatus: this.latfStatus });
  }

  getIconPath(): string {
    if (this.latfStatus === LaftStatus.Error) return 'assets/icons/warning-2.svg';
    return this.isCompleted() ? 'assets/icons/check_circle-24px.svg' : 'assets/icons/outline-receipt-edit.svg';
  }
}
